import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./signup.css";
import ServiceStore from "../../utils/ServiceStore";
import imgeurl from "../../utils/constant";
import { Row, Col, Label, Form } from "reactstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
// import { format, parseISO, isAfter } from "date-fns";
import { format, parseISO, isBefore, isAfter, isToday } from "date-fns";
import { toast } from "react-toastify";

const SignUp = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const currentDate = new Date();
  const maxDate = format(currentDate, "yyyy-MM-dd");
  const [isInvalidDate, setIsInvalidDate] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isMobileError, setIsMobileError] = useState(false);
  const [isEmailErrorMessage, setIsEmailErrorMessage] = useState("");
  const [isMobileErrorMessage, setIsMobileErrorMessage] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [Mobile, setMobile] = useState("");
  const [emailTextfiled, setEmailTextfiled] = useState(false);
  const [mobileTextfiled, setMobileTextfiled] = useState(false);
  const [Email, setEmail] = useState("");
  const [EmailText, setEmailText] = useState("ईमेल सत्यापित करा");
  const [MobileText, setMobileText] = useState("फोन सत्यापित करा");
  const [EmailOTP, setEmailOTP] = useState();
  const [MobileOTP, setMobileOTP] = useState();

  useEffect(() => {}, [isEmailError, isMobileError]);
  const handleDateChange = (e) => {
    const selectedDate = parseISO(e.target.value);
    if (isAfter(selectedDate, currentDate) || isToday(selectedDate)) {
      setIsInvalidDate(true); // Date is in the future or today, show error
    } else {
      setIsInvalidDate(false); // Date is in the past, no error
      setValue("birth", e.target.value); // Update the form value for birth date
    }
  };
  const onSubmit = (e) => {
    if (EmailText === "सत्यापित" && MobileText === "सत्यापित") {
      // const data = e;
      const data = e;
      const birthDate = parseISO(data.birth);
      if (isAfter(birthDate, currentDate)) {
        setIsInvalidDate(true);
        return; // Do not proceed with the form submission if birth date is in the future
      }
      const method = "user/register";
      new ServiceStore()
        .InsertData(method, data)
        .then((res) => {
          if (res.response.status === 1) {
            toast.success("वापरकर्त्याने यशस्वीरित्या नोंदणी केली आहे!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            history.push("Marathi/Login");
          } else {
            throw new Error("An error occurred during registration");
          }
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 500") {
            toast.warn("नेटवर्क त्रुटी!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          let string = error.response.data.message;
          if (string.search("Email and Mobile") == 0) {
            setIsEmailError(true);
            setIsEmailErrorMessage(
              error.response.data.message ? 'ईमेल आणि भ्रमणध्वनी नंबर आधीच वापरलेले आहेत' : error
            );
            setIsMobileError(true);
            setIsMobileErrorMessage(
              error.response.data.message ? 'ईमेल आणि भ्रमणध्वनी नंबर आधीच वापरलेले आहेत' : error
            );
          } else if (string.search("Mobile") == 0) {
            setIsMobileError(true);
            setIsEmailError(false);
            setIsMobileErrorMessage(
              error.response.data.message ? 'भ्रमणध्वनी नंबर आधीच वापरला आहे' : error
            );
          } else {
            setIsEmailError(true);
            setIsMobileError(false);
            setIsEmailErrorMessage(
              error.response.data.message ? 'ई-मेल आधीच वापरला आहे' : error
            );
          }
        });
    }
  };
  const handleKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 32
    ) {
      return true; // Allow alphabetic characters and space
    } else {
      e.preventDefault();
      return false; // Prevent input of other characters
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleMobileNumberChange = (e) => {
    const inputValue = e.target.value;
    if (/^[0-9]{0,10}$/.test(inputValue) || inputValue.lenght === 10) {
      setMobile(inputValue);
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  const formClass = classNames({
    "form-validate": true,
  });

  const handleVerify = (text) => {
    if (text === "email") {
      const method = "user/verifyUser";
      const data = {
        email: Email,
      };
      new ServiceStore()
        .InsertData(method, data)
        .then((res) => {
          if (res.response.status === 1) {
            toast.success("ओटीपी यशस्वीरित्या पाठवले!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            sessionStorage.setItem("verifyEmailOTP", res.response.data);
            setEmailTextfiled(true);
            setMobileTextfiled(false);
          } else {
            throw new Error("An error occurred during registration");
          }
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 500") {
            toast.warn("नेटवर्क त्रुटी!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    } else {
      const method = "user/verifyUser";
      const data = {
        email: Mobile,
      };
      new ServiceStore()
        .InsertData(method, data)
        .then((res) => {
          if (res.response.status === 1) {
            toast.success("ओटीपी यशस्वीरित्या पाठवले!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            sessionStorage.setItem("verifyMobileOTP", res.response.data);
            setMobileTextfiled(true);
            setEmailTextfiled(false);
          } else {
            throw new Error("An error occurred during registration");
          }
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 500") {
            toast.warn("नेटवर्क त्रुटी!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };

  const handleOTPChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if (name === "mobileOtp") {
      setMobileOTP(value);
    } else {
      setEmailOTP(value);
    }
  };

  const verifyOTP = (text) => {
    if (text === "email") {
      if (sessionStorage.getItem("verifyEmailOTP") === EmailOTP) {
        toast.success("ओटीपी सत्यापित!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setEmailText("सत्यापित");
        setEmailTextfiled(false);
      } else {
        toast.error("ओटीपी अवैध!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      if (sessionStorage.getItem("verifyMobileOTP") === MobileOTP) {
        toast.success("ओटीपी सत्यापित!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setMobileText("सत्यापित");
        setMobileTextfiled(false);
      } else {
        toast.error("ओटीपी अवैध!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  return (
    <>
      <div className="container-fluid class-sign">
        <div className="row">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="logo-head">
                      <Link to="/Marathi/Home">
                        <img src="../../images/logo.png" />
                      </Link>
                    </div>
                    <div className="form-div">
                      <h5 className="signup-head">साइन अप करा</h5>
                      <Form
                        className={formClass}
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <div className="form-group">
                          <label>पूर्ण नाव</label>
                          <input
                            className="form-control"
                            type="text"
                            name="name"
                            id="name"
                            onKeyPress={handleKeyPress}
                            placeholder="पूर्ण नाव प्रविष्ट करा"
                            {...register("name", {
                              required: "नाव आवश्यक",
                            })}
                          />
                          {errors.message && errors.message.message}
                        </div>
                        <div className="form-group">
                          <label>ई - मेल आयडी</label>
                          <div className="email-container">
                            <div className="first-container">
                              <input
                                className="form-control"
                                type="email"
                                name="email"
                                id="email"
                                placeholder="ईमेल आयडी टाका"
                                {...register("email", {
                                  required: "ईमेल आवश्यक",
                                })}
                                onChange={handleEmailChange}
                              />
                            </div>
                            <div className="second-container">
                              {!emailTextfiled && (
                                <button disabled={EmailText === 'सत्यापित'} onClick={() => handleVerify("email")}>
                                  {EmailText}
                                </button>
                              )}
                            </div>
                          </div>
                          {errors.message && errors.message.message}
                          <span className="errorMessage">
                            {isEmailError && isEmailErrorMessage}
                          </span>
                        </div>
                        {emailTextfiled && (
                          <div className="form-group">
                            <label>ईमेल ओटीपी प्रविष्ट करा</label>
                            <div className="email-container">
                              <div className="first-container">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="emailOtp"
                                  placeholder="ईमेल ओटीपी प्रविष्ट करा"
                                  onChange={handleOTPChange}
                                />
                              </div>
                              <div className="second-container">
                                <button onClick={() => verifyOTP("email")}>
                                ओटीपी सत्यापित करा
                                </button>
                              </div>
                            </div>
                            {errors.message && errors.message.message}
                          </div>
                        )}
                        <div className="form-group">
                          <label>भ्रमणध्वनी क्रमांक</label>
                          <div className="email-container">
                            <div className="first-container">
                              <input
                                className="form-control"
                                type="tel"
                                name="mobile"
                                id="mobile"
                                value={Mobile}
                                pattern="[0-9]{10}"
                                placeholder="१२३४५६७८९०"
                                {...register("mobile", {
                                  required: "भ्रमणध्वनी आवश्यक",
                                })}
                                onInput={(e) => {
                                  e.target.value = e.target.value.slice(0, 10); // Limit the input to 10 digits
                                }}
                                onChange={handleMobileNumberChange}
                              />
                            </div>
                            <div className="second-container">
                              {!mobileTextfiled && (
                                <button disabled={MobileText === 'सत्यापित'} onClick={() => handleVerify("mobile")}>
                                  {MobileText}
                                </button>
                              )}
                            </div>
                          </div>
                          {errors.message && errors.message.message}
                          {/* <span className="errorMessage">
                            {isMobileError && isMobileErrorMessage}
                          </span> */}
                          <span className="errorMessage">
                            {isMobile && "वैध भ्रमणध्वनी क्रमांक टाका"}
                          </span>
                        </div>
                        {mobileTextfiled && (
                          <div className="form-group">
                            <label>भ्रमणध्वनी ओटीपी प्रविष्ट करा</label>
                            <div className="email-container">
                              <div className="first-container">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="mobileOtp"
                                  placeholder="भ्रमणध्वनी ओटीपी प्रविष्ट करा"
                                  onChange={handleOTPChange}
                                />
                              </div>
                              <div className="second-container">
                                <button onClick={() => verifyOTP("mobile")}>
                                ओटीपी सत्यापित करा
                                </button>
                              </div>
                            </div>
                            {errors.message && errors.message.message}
                            <span className="errorMessage">
                              {isEmailError && isEmailErrorMessage}
                            </span>
                          </div>
                        )}
                        <div className="form-group">
                          <label>जन्मदिनांक</label>
                          <input
                            className="form-control"
                            type="date"
                            name="birth"
                            id="birth"
                            placeholder="दिनांक/महिना/वर्ष"
                            {...register("birth", {
                              required: "जन्मतारीख आवश्यक",
                            })}
                            onChange={handleDateChange}
                            max={maxDate}
                          />
                          {isInvalidDate && (
                            <span className="errorMessage">
                              कृपया योग्य जन्मतारीख निवडा
                            </span>
                          )}
                          {errors.message && errors.message.message}
                        </div>
                        <div className="form-group">
                          <label>लिंग</label>
                          <div className="gender-label">
                            <input
                              type="radio"
                              id="Male"
                              name="gender"
                              value="Male"
                              defaultChecked="true"
                              {...register("gender")}
                            />
                            <label className="label-radio">पुरुष</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              type="radio"
                              id="Female"
                              name="gender"
                              value="Female"
                              {...register("gender")}
                            />
                            <label className="label-radio">स्त्री</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              type="radio"
                              id="Other"
                              name="gender"
                              value="Other"
                              {...register("gender")}
                            />
                            <label className="label-radio">इतर</label>
                          </div>
                        </div>
                        <button className="account-btn">खाते तयार करा</button>
                        <div className="login-bottom">
                          <p>आधीपासूनच एक खाते आहे?</p>
                          <Link to="/Marathi/Login">लॉगिन करा</Link>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 pad-none">
                <div className="right-side-image">
                  <div className="quotes-class">
                    {/* <span>
                      The earth, the air, the land and the water are<br></br>
                      not an inheritance<br></br>
                      from our fore fathers but on loan from our children.
                      <br></br>
                      So we have to handover to them at<br></br>
                      least as it was handed over to us.<br></br>
                      <span className="gandhi">- Mahatma Gandhi</span>
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
